<div class="conversation">
    <div #scrollContainer class="messages">
        @for (message of messages(); track message.message) {
            <div class="message" [class.self]="message.isFromShareholder === !!shareholderId()">
                <div class="time">
                    {{ message.sendTime | date: 'shortTime' : '' : currentLocaleCode }}
                </div>
                <div class="content">
                    {{ message.message }}
                </div>
            </div>
        }

        @if (isSending()) {
            <div class="sending-message">
                {{ 'General.Sending' | translate }}
            </div>
        }
    </div>
    <div class="new">
        <div class="message">
            <textarea
                #messageTxt
                (input)="setMessage($any($event.target).value)"
                [attr.maxlength]="maxMessageLength"
                (keydown.enter)="sendMessage($any($event))"
                placeholder="{{ 'General.TypeNewMessage' | translate }}"
                rows="2"></textarea>
            <div class="remaining-chars">
                <label [class.text-danger]="message.length >= maxMessageLength">
                    {{ message.length }}/{{ maxMessageLength }} {{ 'General.Characters' | translate }}
                </label>
            </div>
        </div>
        <div class="send">
            <button mat-fab color="primary" (click)="sendMessage()" [disabled]="isSending() || !message">
                <mat-icon>send</mat-icon>
            </button>
        </div>
    </div>
</div>
